import React from 'react';
import classnames from 'classnames';

import s from './CentralColumn.scss';

export interface Props {
  supportSidebar?: boolean;
  className?: string;
}

const CentralColumn: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  children,
  supportSidebar,
}) => {
  return (
    <div className={classnames(s['root'], supportSidebar && s['sidebar'], className)}>
      {children}
    </div>
  );
};
CentralColumn.displayName = 'CentralColumn';

export default CentralColumn;
